import OrganizationEmailIdentityConnect from "./OrganizationEmailIdentityConnect"

export default OrganizationEmailIdentityConnect
